import { render, staticRenderFns } from "./InfoCardTab.vue?vue&type=template&id=79e85752&"
import script from "./InfoCardTab.vue?vue&type=script&lang=js&"
export * from "./InfoCardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports